"use strict";

exports.__esModule = true;
exports["default"] = getPartnerUrls;
function getPartnerUrls(env, urlType) {
  var defaultUrls = {
    documentationUrl: env == null ? void 0 : env.defaultDocumentationUrl,
    customerSupportUrl: env == null ? void 0 : env.defaultCustomerSupportUrl
  };
  return env != null && env.licence != null && env.licence[urlType] != null && env.licence[urlType] !== "" ? env.licence[urlType] : defaultUrls[urlType];
}